import { jsonToGraphQLQuery } from 'json-to-graphql-query';
//santiago, implementar con localstorage
let service_addres = 'http://localhost:8080/ServiciosVueJs/recursos/dj';

export default class SmartService {
    async setAmbiente() {
        var urlApiTuMIDES = '';
        var urlApiMIDES = '';
        var urlIDUruguay = '';
        var urlLogin = '';
        var urlLogout = '';
        var urlCU="";
        var client_id = '';
        let ambiente = '';
        const url = window.location.href;
        if (url.includes('localhost')) {
            ambiente = 'local';
        } else if (url.includes('-int.mides.gub.uy/')) {
            ambiente = 'integracion';
        } else if (url.includes('-prep.mides.gub.uy/')) {
            ambiente = 'pre';
        } else {
            ambiente = 'produccion';
        }

        switch (ambiente) {
            case 'local':
                urlApiMIDES = 'https://apis-integra.mides.gub.uy/api_codigueras';
                urlApiTuMIDES = 'https://apitumides-int.mides.gub.uy/graphql';
                urlIDUruguay = 'https://auth-testing.iduruguay.gub.uy/oidc/v1';
                urlLogin = 'https://apps-int.mides.gub.uy/tuMIDES/#/iduy-login';
                urlLogout = 'https://apps-int.mides.gub.uy/tuMIDES/#/iduy-logout';
                urlCU="https://testtramites.mides.gub.uy/telmidesv2/portal/tramite.jsp?id=1001&envId=1";
                client_id = '682300';
                break;
            case 'integracion':
                urlApiMIDES = 'https://apis-integra.mides.gub.uy/api_codigueras';
                urlApiTuMIDES = 'https://apitumides-int.mides.gub.uy/graphql';
                urlIDUruguay = 'https://auth-testing.iduruguay.gub.uy/oidc/v1';
                urlLogin = 'https://apps-int.mides.gub.uy/tuMIDES/iduy-login';
                urlLogout = 'https://apps-int.mides.gub.uy/tuMIDES/iduy-logout';
                urlCU="https://testtramites.mides.gub.uy/telmidesv2/portal/tramite.jsp?id=1001&envId=1";
                client_id = '682300';
                break;
            case 'pre':
                break;
            case 'produccion':
                urlApiMIDES = 'https://apis.mides.gub.uy/api_codigueras';
                urlApiTuMIDES = 'https://apitumides.mides.gub.uy/graphql';
                urlIDUruguay = 'https://auth.iduruguay.gub.uy/oidc/v1';
                urlLogin = 'https://apps.mides.gub.uy/tuMIDES/iduy-login';
                urlLogout = 'https://apps.mides.gub.uy/tuMIDES/iduy-logout';
                urlCU="https://tramites.mides.gub.uy/telmidesv2/portal/tramite.jsp?id=1001&envId=1";
                client_id = '257647';
                break;
        }
        localStorage.urlApiMIDES = urlApiMIDES;
        localStorage.urlApiTuMIDES = urlApiTuMIDES;
        localStorage.urlIDUruguay = urlIDUruguay;
        localStorage.urlLogin = urlLogin;
        localStorage.urlLogout = urlLogout;
        localStorage.urlCU = urlCU;
        localStorage.client_id = client_id;
        localStorage.ambiente = ambiente;
    }

    async autenticarIDU(codigo) {
        const query = {
            mutation: {
                loginIDUruguay: {
                    __args: {
                        code: codigo,
                    },
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors' },
            body: '{"query":' + JSON.stringify(graphql_query) + '}',
        });
        const tokenJson = await res.json();
        if (tokenJson.error) {
            return console.log(tokenJson.error);
        }
        const data = await JSON.parse(tokenJson.data.loginIDUruguay);
        console.log(JSON.stringify(data,null,'\t')); 
        return data;
    }

    async autenticar(doc, id, serie, tipo, tokenCaptcha) {
        try {
            const query = {
                mutation: {
                    loginTUMIDES: {
                        __args: {
                            nroIdentificacion: id,
                            nroSerie: serie,
                            nroDocumento: doc,
                            tipoDocumento: tipo,
                            tokenCaptcha: tokenCaptcha,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors' },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const tokenJson = await res.json();
            if (tokenJson.error) {
                return console.log(tokenJson.error);
            }
            const token = tokenJson.data.loginTUMIDES;
            return token;
        } catch (error) {
            console.log(error);
        }
    }

    async  autenticarTecnico(usuario, pass, doc) {
		try {
			const query = {mutation: {
				loginTecnico:{
					__args: {
						user: usuario,
						password: pass,
						nroDocumento: doc}
			}}};
			const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
			const res = await fetch(localStorage.urlApiTuMIDES, {
					method: 'POST',
					headers: {'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Mode': 'no-cors',
					},
					body: '{"query":'+JSON.stringify(graphql_query)+'}',
				});
			const tokenJson = await res.json();
			if(tokenJson.error){
				return console.log(tokenJson.error)
			}
			const token = tokenJson.data.loginTecnico;
			return token;
		} catch (error) {
			console.log(error)
		}
	}

    async getPersona() {
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":"{obtenerDatosBasicosPersona}"}',
        });
        if (res.error) {
            return console.log(res.error);
        }

        const person = await res.json();
        const data = await JSON.parse(person.data.obtenerDatosBasicosPersona);
        return data.data.obtenerPersona;
    }

    async getTelefonos() {
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":"{obtenerTelefonosPersona}"}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const person = await res.json();
        const data = JSON.parse(person.data.obtenerTelefonosPersona);
        return data.data.obtenerTelefonosPersonaXDocumento;
    }

    async getMails() {
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":"{obtenerCorreosPersona}"}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const person = await res.json();
        const data = JSON.parse(person.data.obtenerCorreosPersona);
        return data.data.obtenerCorreosPersonaXPerId;
    }

    async getTramites() {
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":"{listarTramitesVigentes {id serialversionuid traDescripcion traDesde traHasta traNombre traURL}}"}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const person = await res.json();
        /* console.log(JSON.stringify(person,null,'\t')); */
        return person.data.listarTramitesVigentes;
    }

    async getIntervenciones() {
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":"{obtenerIntervencionesActivasPersona}"}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const person = await res.json();
        const data = JSON.parse(person.data.obtenerIntervencionesActivasPersona);
        return data.data.obtenerIntervencionesPersonaXEstados;
    }

    async editTelefono(tipo, obs, viejo, nuevo) {
        try {
            const query = {
                mutation: {
                    modificarTelefonoPersona: {
                        __args: {
                            tipoTelefonoNuevo: tipo,
                            observacionTelefonoNuevo: obs,
                            nroTelefonoAModificar: viejo,
                            nroTelefonoNuevo: nuevo,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const tokenJson = await res.json();
            if (tokenJson.error) {
                return console.log(tokenJson.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async altaTelefono(tipo, obs, nuevo) {
        try {
            const query = {
                mutation: {
                    altaTelefonoPersona: {
                        __args: {
                            tipoTelefono: tipo,
                            observacionTelefono: obs,
                            nroTelefono: nuevo,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const tokenJson = await res.json();
            if (tokenJson.error) {
                return console.log(tokenJson.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async bajaTelefono(codigo) {
        try {
            const query = {
                mutation: {
                    eliminarTelefonoPersona: {
                        __args: {
                            codigoTelefono: '' + codigo,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const tokenJson = await res.json();
            if (tokenJson.error) {
                return console.log(tokenJson.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async editMail(tipo, viejo, nuevo) {
        try {
            const query = {
                mutation: {
                    modificarCorreoPersona: {
                        __args: {
                            tipoCorreoNuevo: tipo,
                            correoAModificar: viejo,
                            correoNuevo: nuevo,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const tokenJson = await res.json();
            if (tokenJson.error) {
                return console.log(tokenJson.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async altaMail(tipo, nuevo) {
        try {
            const query = {
                mutation: {
                    altaCorreoPersona: {
                        __args: {
                            tipoCorreo: tipo,
                            correo: nuevo,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const tokenJson = await res.json();
            if (tokenJson.errors.length > 0) {
                return -1;
            } else return 1;
        } catch (error) {
            console.log(error);
        }
    }

    async bajaMail(correo) {
        try {
            const query = {
                mutation: {
                    eliminarCorreoPersona: {
                        __args: {
                            correoAEliminar: correo,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const tokenJson = await res.json();
            if (tokenJson.error) {
                return console.log(tokenJson.error);
            }
        } catch (error) {
            console.log(error);
        }
    }

    async afam(tel, depto) {
        try {
            const query = {
                mutation: {
                    insertarPersonaAfamTuApp: {
                        __args: {
                            telefono: tel,
                            depCod: depto,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const result = await res.json();
            const data = JSON.parse(result.data.insertarPersonaAfamTuApp);
            return data.data.insertarPersonaAfamTuApp;
        } catch (error) {
            console.log(error);
        }
    }

    async asistentes(tel, depto, localidad) {
		try {
			const query = {mutation: {
				insertarPersonaAsistenteTuMides:{
					__args: {
						telefono: tel,
						depCod: depto,
						locCod: localidad
					}
			}}};
			const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
			const res = await fetch(localStorage.urlApiTuMIDES, {
					method: 'POST',
					headers: {'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Mode': 'no-cors',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + localStorage.token,
					},
					body: '{"query":'+JSON.stringify(graphql_query)+'}',
				});
			const result = await res.json();
			const data = JSON.parse(result.data.insertarPersonaAsistenteTuMides);
			return data.data.insertarPersonaAsistenteTuMides;
		} catch (error) {
			console.log(error)
		}
	}

    async logout() {
        try {
            const query = {
                mutation: {
                    logout: {},
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const result = await res.json();
            const data = JSON.parse(result.data.logout);
            return data.ExternalToken;
        } catch (error) {
            console.log(error);
        }
    }

    async enviarOTP(cel) {
        const query = {
            enviarOTP: {
                __args: {
                    celular: cel,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const person = await res.json();
        const data = JSON.parse(person.data.enviarOTP);
        return data;
    }

    async validarOTP(cel, cod) {
        const query = {
            validarOTP: {
                __args: {
                    celular: cel,
                    codigo: cod,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const person = await res.json();
        const data = JSON.parse(person.data.validarOTP);
        return data;
    }

    //SECCION DE DIRECCIONES Y LOCALIZACION
    async getDireccion(perId) {
        const response = await fetch(service_addres + '/obtenerDireccion?perId=' + perId);
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    }

    async getDptos() {
        const response = await fetch(localStorage.urlApiMIDES + '/geo2.Departamento');
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    }


    async getLocalidad(depId) {
        const response = await fetch(localStorage.urlApiMIDES + '/geo2.localidad?DepId=' + depId)
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    }

    async getCalle(depId, locId) {
        const response = await fetch(localStorage.urlApiMIDES + '/geo2.viatransito?DepId=' + depId + '&LocId=' + locId);
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    }

    async getSeccionJudicial(depId) {
        const response = await fetch(localStorage.urlApiMIDES + '/geo2.SeccionPolicial?DepId=' + depId);
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    }

    async getCodigoPostal(depId, locId) {
        const response = await fetch(localStorage.urlApiMIDES + '/geo2.CodigoPostal?DepId=' + depId + '&LocId=' + locId);
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    }

    //SALDO TUS
    async getSaldoTUS() {
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":"{obtenerSaldoTUS}"}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const resj = await res.json();
        if (!resj.errors){
            const saldo = JSON.parse(resj.data.obtenerSaldoTUS);
            return saldo.data.obtenerSaldoTUS;
        }
    }

    async getFechaCargaTUS() {
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":"{obtenerFechaCargaTUS}"}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const resj = await res.json();
        if (!resj.errors){
            const fecha = JSON.parse(resj.data.obtenerFechaCargaTUS);
            return fecha.data.obtenerFechaCargaTUS;
        }
    }
	async validarAfam() {
		try {
			const res = await fetch(localStorage.urlApiTuMIDES, {
					method: 'POST',
					headers: {'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Mode': 'no-cors',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + localStorage.token,
					},
					body: '{"query":"{esBeneficiarioAfamTuApp}"}',
				});
			const result = await res.json();
			const data = JSON.parse(result.data.esBeneficiarioAfamTuApp);
			return data.data.esBeneficiarioAfamTuApp;
		} catch (error) {
			console.log(error)
		}
	}

    /* async getComedoresCupo() {
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":"{obtenerComedoresDisponibles}"}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const resj = await res.json();
        if (!resj.errors){
            const comedores = JSON.parse(resj.data.obtenerComedoresDisponibles);
            //console.log(JSON.stringify(comedores,null,'\t')); 
            return comedores.data.obtenerComedoresDisponibles;
        }
    } */

    async getComedoresCupo(motivoId) {
        const query = {
            obtenerComedoresDisponibles: {
                __args: {
                    idMotivo: motivoId,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const result = await res.json();
        if (!result.errors){
            const comedores = JSON.parse(result.data.obtenerComedoresDisponibles);
            return comedores.data.obtenerComedoresDisponiblesPorMotivo;
            //return comedores;
        }
        else{
            const comedores = result.errors[0];
            console.log(comedores.message);
            return comedores.message;
        }
    }
    
    async getHogar() {
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":"{obtenerHogar}"}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const resj = await res.json();
        if (!resj.errors){
            const hogar = JSON.parse(resj.data.obtenerHogar);
            /* console.log(JSON.stringify(hogar,null,'\t')); */
            return hogar.data.obtenerHogar;
        }
    }

    async getDietas() {
        const response = await fetch(localStorage.urlApiMIDES + '/come.CodTipoDieta');
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        /* console.log(JSON.stringify(data,null,'\t')); */
        return data;
    }

    async getModalidades() {
        const response = await fetch(localStorage.urlApiMIDES + '/come.CodModalidad');
        const data = await response.json();
        if (!response.ok) {
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        /* console.log(JSON.stringify(data,null,'\t')); */
        return data;
    }

    async comedores(formulario) {
        try {
            const query = {
                mutation: {
                    crearIntervencionSNC: {
                        __args: {
                            formularioVC:formulario,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const result = await res.json();
            const data = JSON.parse(result.data.crearIntervencionSNC);
            /* console.log("Estoy en el WS comedores");
            console.log(JSON.stringify(data,null,'\t')); */
            return data.data.crearIntervencionSNC;
        } catch (error) {
            console.log(error);
        }
    }

    async obtenerDatosPostulacion(pId) {
        const query = {
            obtenerPostulacion: {
                __args: {
                    id: pId,
                },
            },
        };
        const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
        const res = await fetch(localStorage.urlApiTuMIDES, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
            body: '{"query":' + JSON.stringify('{' + graphql_query + '}') + '}',
        });
        if (res.error) {
            return console.log(res.error);
        }
        const result = await res.json();
        if (!result.errors){
            const datosPost = JSON.parse(result.data.obtenerPostulacion);
            return datosPost;
        }
        else{
            const datosPost = result.errors[0];
            console.log(datosPost.message);
            return datosPost.message;
        }
    }

    async garrafas(tel, depto) {
        try {
            const query = {
                mutation: {
                    postulacionGarrafas: {
                        __args: {
                            nroTelefono: tel,
                            depId: depto,
                        },
                    },
                },
            };
            const graphql_query = jsonToGraphQLQuery(query, { pretty: true });
            const res = await fetch(localStorage.urlApiTuMIDES, {
                method: 'POST',
                headers: { Accept: 'application/json', 'Content-Type': 'application/json', Mode: 'no-cors', 'Access-Control-Allow-Origin': '*', Authorization: 'Bearer ' + localStorage.token },
                body: '{"query":' + JSON.stringify(graphql_query) + '}',
            });
            const result = await res.json();
            const data = JSON.parse(result.data.postulacionGarrafas);
            return data.data.postulacionGarrafas;
        } catch (error) {
            console.log(error);
        }
    }
}
